import React, { useState } from 'react';
import cx from 'classnames';
import { SortByType, SortDirectionEnum } from 'sharedTypes/common/sortByType';

import SVGIcon from '@arrive/svg-icon';
import SelectableListPopover from '@arrive/selectable-list-popover';

import SORT from '@arrive/ui-icons/svg/ic_sort.svg';
import CLOSE from '@arrive/ui-icons/svg/ic_close.svg';

import styles from './LaneSortingDropdown.scss';

export type SortOptions = { [key: string]: { id: string; content: string } };
export type SortOption = { id: string; content: string };

interface Props {
  className?: string;
  selectedSort: SortByType;
  onSortChange: (newSort: SortByType) => void;
  sortOptions: Array<SortOption>;
  testId?: string;
}

export default function LaneSortingDropdown({ className, selectedSort, onSortChange, sortOptions, testId }: Props) {
  const [showPopover, setShowPopover] = useState(false);
  const selectedSortId = `${selectedSort.ColumnToSort}-${selectedSort.SortDirection}`;

  const handleSortChange = (newSort: Array<string>) => {
    // An option must be selected
    if (newSort.length) {
      const itemSplit = newSort[0].split('-');
      onSortChange({
        ColumnToSort: itemSplit[0],
        SortDirection: itemSplit[1] as SortDirectionEnum
      });
      setShowPopover(false);
    }
  }

  return (
    <SelectableListPopover
      showPopover={showPopover}
      setShowPopover={setShowPopover}
      options={Object.values(sortOptions)}
      selectedOptionIds={[selectedSortId]}
      onChange={handleSortChange}
      matchAnchorWidth
      placement='bottom'
      classes={{
        listContainerClass: styles.listContainer,
        anchorClass: styles.anchorClass
      }}
      title='Sort By'
    >
      <button
        data-testid={testId}
        className={cx(styles.sortBy, className, { [styles.isOpen]: showPopover })}
        onClick={(e) => {
          if (!showPopover) {
            setShowPopover(!showPopover);
            e.stopPropagation();
          }
        }}
      >
        { !showPopover && <SVGIcon className={styles.icon} svgRef={SORT} /> }
        { showPopover &&
          <>
            Sort By:
            <button data-testid="close-sort-by" aria-label="close Sort By" className={styles.invisibleButtonWrapper} onClick={(e) => {
              setShowPopover(!showPopover);
              e.stopPropagation();
            }}>
              <SVGIcon className={cx(styles.icon, styles.clickableIcon)} svgRef={CLOSE} />
            </button>
          </>
        }
      </button>
    </SelectableListPopover>
  )
}
